const PATHS = {
  token: "/token",
  wallet: "/wallet",
  home: "/",
  partners: "/partners",
  appstore: "https://apps.apple.com/us/app/sweat-wallet/id1619316571",
  googleplay: "https://play.google.com/store/apps/details?id=com.sweatwallet",
  x: "https://x.com/SweatEconomy",
  telegram: "https://t.me/SweatEconomyAnnouncements",
  discord: "https://discord.com/invite/sweateconomy",
  facebook: "https://www.facebook.com/sweateconomy",
  reddit: "https://www.reddit.com/r/Sweateconomy",
  instagram: "https://www.instagram.com/sweateconomy",
  blog: "https://medium.com/sweat-economy",
  tokenomics: "/token#tokenomics",
  // dao: "",
  lightpaper: "https://whitepaper.swe.at/",
  activeDayValue: "/active-day-value",
  privacyPolicy: "/privacy",
  termsAndConditions: "/tnc",
  growTerms: "/grow-terms",
  helpCenter: "https://help.sweateconomy.com/hc/en-us",
  bugBounty: "https://immunefi.com/bug-bounty/sweateconomy/information/",
  mediaKit: "/media-kit",
  emissionLink: "/token#emissions",
  about: "/token#tokenomics",
  more: "/whitepaper",
  coingeckoSweat: "https://www.coingecko.com/en/coins/sweat-economy",

  bookCall: "",
  downloadPartnershipDeck: "",
  getInTouch: "https://sweatcoin3.typeform.com/to/J4pJdOX0",

  rewards: "",
};

export { PATHS };
